export enum CommunicationShortcutIcon {
    ShortcutLinkNotifyUsers = 'fa fa-at',
    ShortcutLinkAttachments = 'fa fa-hashtag',
    ShortcutLinkSurveys = 'fa fa-exclamation',
    ShortcutLinkDeclarations = 'fa fa-exclamation'
  }
